export default $testPeriod => {
  const getTestPeriod = () => $testPeriod.testPeriod
  return { getTestPeriod }
}
